// FILE: stratify_website/src/pages/MarcoSchapiraPage.jsx
import React from "react";
import { SITE } from "../config/site";
import { Meta } from "../layout/EducationMeta";
import GlassCard from "../components/ui/GlassCard";

export default function MarcoSchapiraPage() {
  const canonical = `${SITE.url}/about/marco-schapira`;

  const person = {
    "@context": "https://schema.org",
    "@type": "Person",
    name: "Marco Schapira",
    jobTitle: "Co-Founder & Engineering Lead",
    worksFor: { "@type": "Organization", name: SITE.name, url: SITE.url },
    url: canonical,
    image: `${SITE.url}/images/marcoprofileimage.jpeg`,
    description:
      "Co-founder at Stratify Backtesting focused on engineering, backtesting infrastructure, and reliable strategy systems for monitoring and validation.",
    knowsAbout: [
      "Backtesting systems",
      "Data reliability",
      "Software architecture",
      "Trading strategy infrastructure",
      "Validation and robustness",
      "APIs and integrations",
      "Performance engineering",
    ],
    sameAs: [
      // "https://www.linkedin.com/in/your-link",
      // "https://github.com/your-handle"
    ],
  };

  return (
    <div className="mx-auto w-full max-w-[110rem] px-4 md:px-6 lg:px-8 xl:px-10 2xl:px-12 py-10">
      <Meta
        title="Marco Schapira — Co-Founder & Engineering Lead | Stratify Backtesting"
        description="Marco Schapira is the co-founder and engineering lead at Stratify Backtesting, building reliable backtesting infrastructure and strategy systems for monitoring and validation."
        canonical={canonical}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(person) }}
      />

      <div className="max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-semibold tracking-tight text-ink">
          Marco Schapira
        </h1>
        <p className="mt-2 text-muted">Co-Founder & Engineering Lead, Stratify Backtesting</p>
        <p className="mt-4 text-sm md:text-base text-muted leading-relaxed">
          I focus on the systems that make strategy tools trustworthy —{" "}
          <span className="text-ink">
            reliable backtests, clean data, and monitoring that behaves predictably
          </span>
          .
        </p>
      </div>

      <div className="mt-8 grid gap-6 md:grid-cols-12">
        <GlassCard className="p-6 md:col-span-4">
          <img
            src="/images/marcoprofileimage.jpeg"
            alt="Marco Schapira portrait"
            className="w-full h-auto rounded-2xl ring-1 ring-ink/10 object-cover"
            loading="lazy"
            decoding="async"
          />
        </GlassCard>

        <GlassCard className="p-6 md:col-span-8">
          <div className="text-sm font-semibold text-ink">Bio</div>
          <p className="mt-2 text-sm text-muted leading-relaxed">
            Marco is a co-founder of Stratify Backtesting
          </p>

          <div className="mt-6 grid gap-3 sm:grid-cols-2">
            <div className="rounded-xl border border-ink/8 bg-bg1 p-4">
              <div className="text-xs font-semibold text-ink">Focus</div>
              <div className="mt-1 text-xs text-muted leading-relaxed">

              </div>
            </div>

            <div className="rounded-xl border border-ink/8 bg-bg1 p-4">
              <div className="text-xs font-semibold text-ink">Building</div>
              <div className="mt-1 text-xs text-muted leading-relaxed">

              </div>
            </div>
          </div>

          <div className="mt-5 rounded-xl border border-ink/8 bg-white/[0.02] p-4">
            <div className="text-xs font-semibold text-ink">What I care about</div>
            <div className="mt-1 text-xs text-muted leading-relaxed">

            </div>
          </div>
        </GlassCard>
      </div>
    </div>
  );
}
